PJQ.views.dailyReports.NoteManagement = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Note-Management')
	},
	events: {
		'click .add-note': 'addClicked',
		'click .edit-note': 'editClicked',
		'click .delete-note': 'deleteClicked'
	},
	beforeFirstRender: function () {
		this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.isAdminNotes');

		this.listenTo(this.collection, 'sync', _.bind(function () {
			this.dataTable.refresh();
		}, this));
	},
	beforeRender: function () {
		this.options.isLocked = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.DAILY_REPORT_IS_LOCKED_AFTER_SUBMIT) && this.options.dailyReport.get('status') === 1;
		this.options.canEdit = this.options.project.hasPermission('dailyReports.canAddNotes') && !this.options.isLocked;
	},
	renderData: function () {
		return {
			project: this.options.project,
			canEdit: this.options.canEdit
		};
	},
	afterRender: function () {
		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: '.notes-data-table-container',
			data: this.collection.models,
			isHideSearch: true,
			rowId: 'cid',
			order: [1, 'asc'],
			language: {
				zeroRecords: this.options.canEdit ? 'Click "Add Note" to create a new note' : 'No notes were added for this day'
			},
			onRowDoubleClick: _.bind(function (row) {
				if (!this.isLocked) {
					this.editNote(row.data());
				}
			}, this),
			contextMenuOptions: {
				actions: [
					{
						name: 'Edit',
						onClick: _.bind(function (row) {
							this.editNote(row.data());
						}, this),
						isShown: _.bind(function () {
							return this.options.canEdit;
						}, this)
					},
					{
						name: 'View',
						onClick: _.bind(function (row) {
							this.editNote(row.data());
						}, this),
						isShown: _.bind(function () {
							return !this.options.canEdit;
						}, this)
					},
					{
						name: 'Delete',
						isDanger: true,
						isShown: _.bind(function () {
							return this.options.isAdmin && this.options.canEdit;
						}, this),
						onClick: _.bind(function (row) {
							this.deleteNote(row);
						}, this)
					}
				]
			},
			columns: [
				{
					"data": "attachments",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "40px",
					"render": function (data) {
						let attachmentCount = _.size(data.models);
						return '<div><span class="fal fa-paperclip mr-1 ' + (attachmentCount > 0 ? 'text-success' : 'text-muted') + '"></span><span class="' + (attachmentCount > 0 ? 'text-dark' : 'text-muted') + '">' + attachmentCount.toString() + '</span></div>';
					}
				},
				{
					"data": "attributes.category",
					"title": "Category",
					"width": "25%",
					"render": function (data, type, row) {
						return row.getCategoryName();
					}
				},
				{"data": "attributes.noteText", "title": "Description"},
				{
					"data": "",
					"title": "",
					"orderable": false,
					"searchable": false,
					"width": "80px",
					"render": _.bind(function () {
						let buttons;
						if (this.options.canEdit) {
							buttons = '<button type="button" class="btn btn-info edit-note ht-30p wd-35p mr-1 fs-14"><span class="fal fa-pencil"></span></button>';
						}
						else {
							buttons = '<button type="button" class="btn btn-info edit-note ht-30p wd-35p mr-1 fs-14"><span class="fal fa-search"></span></button>';
						}
						if (this.options.isAdmin && this.options.canEdit) {
							buttons += '<button type="button" class="btn btn-danger delete-note ht-30p wd-35p fs-14"><span class="fal fa-trash"></span></button>';
						}
						return '<div class="text-align-right show-on-row-hover">' + buttons + '</div>';
					}, this)
				}
			]
		});
	},
	addClicked: function () {
		let newNote = new PJQ.models.dailyReports.Note({
			dailyReportId: this.options.dailyReport.id,
			category: 0,
			noteText: ""
		});
		this.editNote(newNote);
	},
	editClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr')),
			note = row.data();
		this.editNote(note);
	},
	editNote: function (note) {
		new PJQ.views.dailyReports.EditNoteModal({
			model: note,
			project: this.options.project,
			isLocked: this.options.isLocked,
			onSave: _.bind(function (note) {
				if (note.hasChanged() || note.isNew()) {
					if (note.isNew()) {
						this.collection.add(note);
						this.dataTable.addRow(note);
					}
					note.save(null, {
						notify: true
					});
					this.dataTable.refresh();
				}
			}, this),
			onClose: _.bind(function (note) {
				if (note.hasChanged()) {
					note.fetch({
						success: _.bind(function () {
							this.dataTable.refresh();
						}, this)
					});
				}
			}, this),
			onDelete: _.bind(function (note) {
				if (note.id > 0) {
					let row = this.dataTable.getRow(note.cid);
					this.collection.remove(note);
					note.destroy();
					if (row != null) {
						this.dataTable.removeRow(row);
					}
				}
			}, this)
		});
	},
	deleteClicked: function (e) {
		let target = $(e.currentTarget),
			row = this.dataTable.getRow(target.closest('tr'));
		this.deleteNote(row);
	},
	deleteNote: function (row) {
		let note = row.data();
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this note?",
			onDelete: _.bind(function () {
				this.collection.remove(note);
				note.destroy();
				this.dataTable.removeRow(row);
			}, this)
		});
	}
});

PJQ.views.dailyReports.EditNoteModal = PJQ.views.BaseModal.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.DAILYREPORTS, 'Modal-Edit-Note'),
		maxWidth: 800
	},
	events: {
		'click .note-save': 'onSave',
		'click .note-close': 'close',
		'click .note-delete': 'onDelete'
	},
	beforeModalCreated: function () {
		this.options.isAdmin = this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.isAdminNotes');
		this.options.canEdit = this.model.isNew() || (this.options.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId')
			&& this.options.project.hasPermission('dailyReports.canAddNotes') && !this.options.isLocked);
	},
	renderData: function () {
		return {
			model: this.model,
			isAdmin: this.options.isAdmin,
			canEdit: this.options.canEdit
		};
	},
	afterRender: function () {
		if (this.options.canEdit) {
			new PJQ.Binder(this.$el, this.model, {
				watchElements: [
					'input',
					'textarea'
				]
			});
		}

		new PJQ.inputs.Selectpicker({
			el: this.$('.note-category'),
			onChange: _.bind(function (value) {
				this.model.set('category', value);
			}, this),
			defaultValue: this.model.get('category')
		});

		this.fileUploader = new PJQ.views.files.FileUploaderGrid({
			el: this.$('.note-file-upload'),
			collection: this.model.attachments,
			canUpload: this.options.canEdit,
			// includeProjectAttachments: true,
			canDelete: this.options.isAdmin && this.options.canEdit,
			previewImageDimension: 150,
			sortDirection: 'asc',
			onDelete: _.bind(function (attachment, callback) {
				if (attachment.id > 0) {
					attachment.set('isDeleted', true);
				}
				else {
					attachment.destroy();
				}
				this.model.isDirty = true;
				callback();
			}, this)
		});
	},
	onSave: function () {
		if (this.fileUploader.isUploading()) {
			new PJQ.views.BaseModal({
				header: "Files Uploading",
				body: "You can't save while files are uploading"
			});
		}
		else {
			if (this.options.onSave) {
				this.options.onSave(this.model);
				this.removeModal();
			}
		}
	},
	close: function () {
		if (this.options.canEdit && this.model.hasChanged()) {
			new PJQ.views.modals.SaveDontSave({
				header: "Unsaved Changes",
				body: "Do you want to save changes?",
				onSave: _.bind(function () {
					this.onSave();
				}, this),
				onDontSave: _.bind(function () {
					this.onClose(this.model);
					this.removeModal();
				}, this)
			});
		}
		else {
			this.onClose(this.model);
			this.removeModal();
		}
	},
	onDelete: function () {
		new PJQ.views.modals.DeleteCancel({
			header: "Confirm Deletion",
			body: "Are you sure you want to delete this note?",
			onDelete: _.bind(function () {
				if (this.options.onDelete) {
					this.options.onDelete(this.model);
				}
				this.removeModal();
			}, this)
		});
	}
});
